import React, { useState, useCallback } from "react";
import { LogoutOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { connect } from "dva";
import { endAccountImpersonation } from "@/utils/session";
import Avatar from "./AvatarDropdown";
import EntityDrodown from "./EntityDropdown";
import styles from "./index.less";

const buttonStyle = {
  marginRight: "8px",
  transition: "all 0.3s ease",
};

const GlobalHeaderRight = ({ theme, layout, dealers, history, currentUser, dispatch }) => {
  const [loadingImpersonation, setLoadingImpersonation] = useState(false);

  let className = styles.right;
  if (theme === "dark" && layout === "topmenu") {
    className = `${styles.right}  ${styles.dark}`;
  }

  const endImpersonation = useCallback(() => {
    setLoadingImpersonation(true);
    endAccountImpersonation({
      cleanConfigPerm: () => {
        dispatch({ type: "configs/cleanConfigPerm" });
      },
    }).finally(() => {
      setLoadingImpersonation(false);
    });
  }, [dispatch]);

  return (
    <div className={className}>
      {dealers.length > 0 && (
        <span>
          <EntityDrodown history={history} />
        </span>
      )}
      {currentUser.impersonatorUserId != null && (
        <div className={styles.buttonWrapper}>
          <Button
            type="primary"
            danger
            loading={loadingImpersonation}
            icon={<LogoutOutlined />}
            onClick={endImpersonation}
            style={buttonStyle}
            className="hover-effect"
          >
            End Impersonation
          </Button>
        </div>
      )}
      <Avatar />
    </div>
  );
};

export default connect(({ settings, user, configs }) => ({
  currentUser: configs.configCurrentUser,
  theme: settings.navTheme,
  layout: settings.layout,
  dealers: user.dealers,
}))(GlobalHeaderRight);
